export default __webpack_public_path__ + "static/media/2217.9591c6ab.png";